
(() => {
  const KEY = 'misey_favoritos_v1';

  function getFavorites() {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(data) ? data : [];
    } catch {
      return [];
    }
  }

  function saveFavorites(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      window.dispatchEvent(new Event('misey:favoritos'));
      return true;
    } catch {
      return false;
    }
  }

  function updateButtons() {
    const ids = new Set(
      getFavorites().map(p => String(p.id))
    );

    document.querySelectorAll('[data-misey-favorito]')
      .forEach(button => {
        const active = ids.has(button.dataset.id);

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute(
          'aria-label',
          `${active ? 'Quitar de' : 'Añadir a'} favoritos: ${button.dataset.title}`
        );
      });
  }

  // Capturar el clic antes que otros eventos de Dawn.
  document.addEventListener('click', event => {
    const button = event.target.closest(
      '[data-misey-favorito]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const favorites = getFavorites();
    const id = button.dataset.id;

    const index = favorites.findIndex(
      p => String(p.id) === id
    );

    if (index >= 0) {
      favorites.splice(index, 1);
    } else {
      favorites.push({
        id,
        handle: button.dataset.handle,
        title: button.dataset.title,
        url: button.dataset.url,
        image: button.dataset.image,
        price: button.dataset.price
      });
    }

    if (!saveFavorites(favorites)) {
      alert(
        'No se han podido guardar los favoritos en este navegador.'
      );
    }

    updateButtons();
  }, true);

  document.addEventListener(
    'DOMContentLoaded',
    updateButtons
  );

  document.addEventListener(
    'shopify:section:load',
    updateButtons
  );

  window.addEventListener(
    'storage',
    updateButtons
  );

  window.addEventListener(
    'misey:favoritos',
    updateButtons
  );

  const observer = new MutationObserver(() => {
    updateButtons();
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  window.MiseyFavoritos = {
    getFavorites,
    updateButtons
  };
})();
